<div class="signature-field">
    <div class="signature-field__metadata">
        <app-material-input
            class="signature-field__name"
            label="Nome do assinante"
            [required]="metadataRequired"
        >
            <input
                type="text"
                maxlength="200"
                [required]="metadataRequired"
                [(ngModel)]="signature.nomeAssinante"
                (ngModelChange)="updateDataValue()"
            >
        </app-material-input>

        <app-material-input
            class="signature-field__cpf"
            label="CPF do assinante"
            [required]="metadataRequired"
        >
            <input
                type="text"
                mask="000.000.000-00"
                [dropSpecialCharacters]="false"
                [required]="metadataRequired"
                appCpfValidator
                [(ngModel)]="signature.cpfAssinante"
                (ngModelChange)="updateDataValue()"
            >
        </app-material-input>
    </div>

    @if (hasStoredSignature) {
        <ui-alert
            variant="info"
            label="Assinatura manuscrita preservada"
        >
            A imagem da assinatura já registrada não será alterada.
            Nesta edição, somente o nome e o CPF do assinante
            podem ser modificados.
        </ui-alert>
    } @else {
        <ui-signature-pad
            [value]="signature.imagemBase64 ?? ''"
            [showCard]="true"
            [showConfirm]="false"
            [showOrientationWarning]="false"
            (valueChange)="updateSignatureImage($event)"
        ></ui-signature-pad>
    }
</div>
